<mat-toolbar id="app-toolbar" [hidden]="!visible">
  <!-- <a routerLink="/" *ngIf="!isAuth || isHandset" style="position: absolute;top:10px;left:10px;">
    <mat-icon svgIcon="site_logo"></mat-icon>
  </a> -->
  <ng-container *ngIf="!isCT; else ctLogo">
    <dp-logo routerLink="/" *ngIf="isAuth && !isHandset" [orgCode]="orgCode" [orgLogo]="fileSrc?.url" [logoMode]="LogoMode.wide"></dp-logo>
  </ng-container>
  <ng-template #ctLogo>
    <img [src]="ctLogoSource" alt="logo" class="ct-logo" />
  </ng-template>

  <span class="spacer">
    <dp-global-search *ngIf="isAccountPlus && !authService.isEximUser"></dp-global-search>
    <!-- <dp-logo routerLink="/" *ngIf="isAuth && !isHandset" [orgCode]="orgCode" [logoMode]="LogoMode.wide"></dp-logo> -->
    <!-- <img src="assets/images/logos/100000076.png" alt="company logo" width="auto" style="height: 35px;"> -->
  </span>
  <mat-form-field *ngIf="languageOptions?.length > 0" [(ngModel)]="currentLanguage" appearance="outline" class="mt-20 mr-8">
    <mat-select class="select-class" [value]="currentLanguage" (selectionChange)="onLanguageChange($event)" panelClass="no-change">
      <mat-option *ngFor="let option of languageOptions" [value]="option.key" class="global-search">{{ option.value }}</mat-option>
    </mat-select>
  </mat-form-field>
  <ul fxLayout fxLayoutGap="10px" fxLayoutAlign="space-around center" class="top-nav-items">
    <li style="padding-right: 2px" [hidden]="!isAuth || currentUser.companyStatus !== LoginCompanyStatusType.VERIFIED">
      <button
        tooltip="Go to Super-Admin page"
        mat-icon-button
        aria-label="Super Admin Tool"
        *ngIf="showSAPageLinkBtn()"
        (click)="goToSAPage()"
      >
        <dp-svg [src]="udsIconMap.user_1"></dp-svg>
      </button>

      <button
        tooltip="Go back to Super-Admin"
        mat-icon-button
        aria-label="Back to admin"
        *ngIf="showSABackBtn()"
        (click)="backToSA()"
        class="mr-8"
      >
        <dp-svg [src]="udsIconMap.user_1"></dp-svg>
      </button>

      <button
        mat-icon-button
        aria-label="Invite Users"
        [mdePopoverTriggerFor]="inviteUserPopover"
        mdePopoverTriggerOn="click"
        *ngIf="isAuth && currentUser.isAdmin && !authService.isEximUser"
        class="mr-4"
        [class]="userAccessService.accessClass(accessKeys.ADD_USER)"
      >
        <dp-svg
          [src]="udsIconMap.HeaderUser"
          [tooltip]="userAccessService.getTooltip(accessKeys.ADD_USER) || 'Add User'"
          placement="bottom"
        ></dp-svg>
      </button>

      <button
        mat-icon-button
        [hidden]="isAccountPlus"  
        [ngClass]="{ withDot: hasNotification }"
        aria-label="Notification"
        #myTrigger="mdePopoverTrigger"
        [mdePopoverTriggerFor]="notificationPopover"
        mdePopoverTriggerOn="click"
        #notificationTrigger="mdePopoverTrigger"
        class="mr-4"
      >
        <dp-svg [src]="udsIconMap.notification" tooltip="Notification" placement="bottom"></dp-svg>
      </button>

      <button
        mat-icon-button
        aria-label="Help Center"
        [mdePopoverTriggerFor]="helpPopover"
        mdePopoverTriggerOn="click"
        *ngIf="isAuth && !authService.isEximUser"
        class="mr-4"
        tooltip="Help Center"
        placement="bottom"
      >
        <dp-svg [src]="udsIconMap.helpCenter"></dp-svg>
      </button>

      <button
        mat-mini-fab
        class="ml-8 easy-button avatar"
        style="box-shadow: none"
        [mdePopoverTriggerFor]="profilePopover"
        mdePopoverTriggerOn="click"
        #profileTrigger="mdePopoverTrigger"
        (opened)="popoverOpened()"
      >
        {{ initials }}
        <mat-icon aria-label="profile" *ngIf="!initials">person</mat-icon>
      </button>
    </li>
    <li fxHide>
      <mat-checkbox [(ngModel)]="applicationSettings.darkMode" (change)="ngDarkModeChange()">Dark</mat-checkbox>
      <br />
    </li>
    <li *ngIf="!isAuth"><a routerLink="/signup">Sign Up</a></li>
    <li *ngIf="!isAuth">
      <a style="margin-right: 15px" routerLink="/login">Login</a>
    </li>
    <!-- <li *ngIf="isAuth"><a (click)="onLogout()">Logout</a></li> -->
  </ul>
</mat-toolbar>

<mde-popover
  #profilePopover="mdePopover"
  [mdePopoverOverlapTrigger]="false"
  [mdePopoverArrowColor]="'var(--primary-brand-main)'"
  [mdePopoverCloseOnClick]="true"
  [class]="'pt-0'"
>
  <mat-card class="p-0 mat-elevation-z12" id="profile-popover-card" *ngIf="currentUser">
    <mat-card-header fxLayout="row" fxLayoutAlign="space-between center" class="header-popover p-4">
      <mat-card-title class="m-0">{{ currentUser.fullName }}</mat-card-title>
      <dp-svg [src]="udsIconMap.closeIcon" w="16" h="16" [color]="'#fff'" class="mr-2"></dp-svg>
    </mat-card-header>
    <mat-list class="userProfileMenu">
      <button mat-menu-item (click)="gotoUserSettings()" *ngIf="!authService.isEximUser">
        <dp-svg [src]="udsIconMap.user_settings" w="20"></dp-svg>
        <span class="pl-8">{{ 'header.user_menu.user_settings_txt' | translate }}</span>
      </button>

      <button mat-menu-item *ngIf="!isAccountPlus && !authService.isEximUser" (click)="gotoCompanySettings()">
        <dp-svg [src]="udsIconMap.company_settings" w="20"></dp-svg>
        <span class="pl-8">{{ 'header.user_menu.company_settings_txt' | translate }}</span>
      </button>
      <button
        mat-menu-item
        (click)="navigateTo('users-teams')"
        [class]="userAccessService.accessClass(accessKeys.MANAGE_USERS)"
        [tooltip]="userAccessService.getTooltip(accessKeys.MANAGE_USERS)"
        *ngIf="!authService.isEximUser"
      >
        <dp-svg [src]="udsIconMap.manage_users" w="20"></dp-svg>
        <span class="pl-8">{{ getManageUsersTeamsLabel() | translate }}</span>
      </button>
      <button
        mat-menu-item
        *ngIf="currentUser?.isGateOutSchedulingEnabled && currentUser?.accessRole == 'ADMIN'"
        (click)="navigateTo('/configure-prioritisation')"
        [class]="userAccessService.accessClass(accessKeys.CONFIGURE_PRIORITISATION_TAB)"
      >
        <dp-svg [src]="udsIconMap.configurePrioritisation" h="20"></dp-svg>
        <span class="pl-8">{{ 'header.user_menu.configure_prioritisation_txt' | translate }}</span>
      </button>
      <button
        mat-menu-item
        (click)="navigateTo('/locations')"
        [class]="userAccessService.accessClass(accessKeys.LOCATIONS_TAB_VISIBILITY)"
        *ngIf="!authService.isEximUser"
      >
        <dp-svg [src]="udsIconMap.locations2" h="20"></dp-svg>
        <span class="pl-8">{{ 'header.user_menu.locations_txt' | translate }}</span>
      </button>
      <button
        mat-menu-item
        (click)="navigateTo('/dnd-cost')"
        [class]="userAccessService.accessClass(accessKeys.STORAGE_COST_TAB_VISIBILITY)"
        *ngIf="currentUser?.accountCapabilities?.isDemurrageDetentionCostEnabled && currentUser?.accessRole == 'ADMIN'"
      >
        <dp-svg [src]="udsIconMap.storage_cost_icon" w="20"></dp-svg>
        <span class="pl-8">{{ 'header.user_menu.d&d_cost_txt' | translate }}</span>
      </button>
      <button mat-menu-item (click)="navigateTo('invoices')" *ngIf="currentUser?.accountCapabilities?.billableState === 'ACTIVE'">
        <dp-svg [src]="udsIconMap.invoices" w="20"></dp-svg>
        <span class="pl-8">{{ 'header.user_menu.invoices_txt' | translate }}</span>
      </button>
      <button
        mat-menu-item
        (click)="navigateTo('product-master')"
        [hidden]="currentUser.accountType === ACCOUNT_TYPES.PLUS"
        [class]="userAccessService.accessClass(accessKeys.PRODUCT_MASTER_TAB_VISIBILITY)"
        *ngIf="!authService.isEximUser"
      >
        <dp-svg [src]="udsIconMap.productMaster" w="20"></dp-svg>
        <span class="pl-8">{{ 'header.user_menu.product_master_txt' | translate }}</span>
      </button>
      <button mat-menu-item (click)="navigateTo('/vehicleMaster')"
        [class]="userAccessService.accessClass(accessKeys.VEHICLE_MASTER_TAB_VISIBILITY)" 
        *ngIf="currentUser?.accountCapabilities?.isTruckShipmentsUploadAllowed">
        <dp-svg [src]="udsIconMap.truck" w="20"></dp-svg>
        <span class="pl-8">{{ 'header.user_menu.vehicle_Master_txt' | translate }}</span>
      </button>
      <button
        *ngIf="currentUser.isAdvancedConsentForRoadTrackingEnabled"
        mat-menu-item
        (click)="navigateTo('advance-consent')"
        [hidden]="currentUser.accountType === ACCOUNT_TYPES.PLUS"
      >
        <dp-svg [src]="udsIconMap.advanceConsent" w="20"></dp-svg>
        <span class="pl-8">{{ 'header.user_menu.advance_consent_txt' | translate }}</span>
      </button>
      <button mat-menu-item (click)="navigateTo('/partners')"
        [class]="userAccessService.accessClass(accessKeys.PARTNERS_MANAGEMENT_TAB_VISIBILITY)" 
        *ngIf="isPartnersManagementEnabled && currentUser?.accessRole == 'ADMIN' && !authService.isEximUser">
        <dp-svg [src]="udsIconMap.partnersManagement" w="20"></dp-svg>
        <span class="pl-8">{{ 'header.user_menu.partners_management_txt' | translate }}</span>
      </button>
      <button
        *ngIf="currentUser?.userPermissions?.currentOrg?.rulebookOptionMenu !== 'HIDE' && isCT"
        mat-menu-item
        (click)="navigateTo('/rulebook')"
      >
        <dp-svg [src]="udsIconMap.company_settings" w="20"></dp-svg>
        <span class="pl-8">{{ 'header.user_menu.rulebook_txt' | translate }}</span>
      </button>
      <button mat-menu-item (click)="logout()">
        <dp-svg [src]="udsIconMap.logout" w="20"></dp-svg>
        <span class="pl-8">{{ 'header.user_menu.logout_txt' | translate }}</span>
      </button>
    </mat-list>
  </mat-card>
</mde-popover>

<mde-popover
  #inviteUserPopover="mdePopover"
  [mdePopoverOverlapTrigger]="false"
  [mdePopoverArrowColor]="'#ffffff'"
  [mdePopoverCloseOnClick]="false"
  [class]="'pt-0'"
>
  <mat-card class="p-0 mat-elevation-z12" id="pendingUser-popover-card">
    <mat-card-content class="mat-card-popover">
      <dp-invite-user-popover (inviteUserClose)="this.closeInviteUsers()"></dp-invite-user-popover>
    </mat-card-content>
  </mat-card>
</mde-popover>

<mde-popover
  #helpPopover="mdePopover"
  [mdePopoverOverlapTrigger]="false"
  [mdePopoverArrowColor]="'var(--primary-brand-main)'"
  [mdePopoverCloseOnClick]="true"
  [class]="'pt-0'"
>
  <mat-card class="p-0 mat-elevation-z12" id="help-popover-card">
    <mat-card-header fxLayout="row" fxLayoutAlign="space-between center" class="system-primary-500 p-4">
      <mat-card-title class="m-0">{{ 'header.help_center.help_center_txt' | translate }}</mat-card-title>
      <mat-icon class="material-icons closeBtn" (click)="closeHelp()"> close </mat-icon>
    </mat-card-header>
    <mat-list class="helpCenter">
      <button mat-menu-item (click)="contactUs()" [class]="userAccessService.accessClass(accessKeys.HELP_SUPPORT_CENTER)">
        <dp-svg [src]="udsIconMap.support" w="18"></dp-svg>
        <span class="pl-8" class="support-label">{{ 'header.help_center.support_center_txt' | translate }}</span>
      </button>
      <button mat-menu-item (click)="playVideo()">
        <dp-svg [src]="udsIconMap.tutorial" w="18"></dp-svg>
        <span class="pl-8">{{ 'header.help_center.tutorial_txt' | translate }}</span>
      </button>
      <button mat-menu-item (click)="openFAQ()">
        <dp-svg [src]="udsIconMap.faq" w="18"></dp-svg>
        <span class="pl-8">{{ 'header.help_center.faq_txt' | translate }}</span>
      </button>
      <button mat-menu-item (click)="downloadUserManual()">
        <dp-svg [src]="udsIconMap.export" w="18"></dp-svg>
        <span class="pl-8">{{ 'header.help_center.download_user_manual_txt' | translate }}</span>
      </button>
    </mat-list>
  </mat-card>
</mde-popover>

<mde-popover
  #notificationPopover="mdePopover"
  [mdePopoverOverlapTrigger]="false"
  [mdePopoverArrowColor]="'#f2f2f2'"
  [mdePopoverCloseOnClick]="false"
  [class]="'pt-0 notification-events'"
  (close)="onCloseNotificationDlg()"
>
  <mat-card class="notification-popover-card" *ngIf="isAuth">
    <div class="title p-42">{{ 'common.notifications_txt' | translate }}</div>
    <mat-icon class="close-button" (click)="notificationTrigger.togglePopover()">close</mat-icon>
    <div class="content">
      <dp-notification-dlg
        [hidden]="showSettings"
        (dismiss)="closeNotification()"
        [opened]="notificationTrigger.popoverOpen && !showSettings"
      >
      </dp-notification-dlg>
      <div *ngIf="showSettings" class="notificationSetting">
        <dp-notification-setting></dp-notification-setting>
      </div>
      <span
        *ngIf="!authService.isEximUser"
        class="material-icons material-icons-outlined settings"
        (click)="toggle()"
        tooltip="{{ showSettings ? 'View notifications' : 'Manage notifications' }}"
      >
        <dp-svg [src]="udsIconMap.user_settings" w="21"> </dp-svg>
      </span>
    </div>
  </mat-card>
</mde-popover>
